import React from 'react'
import './client-booking.css'
import Header from '../components/complex/header'
import ProfessionalsServices from '../components/complex/professionals-services'
import ClientBooking from '../components/complex/client-booking-list'

const screen = () => {
  return (
    <div className='screen-main'>
      <Header />
      <ProfessionalsServices />
      <ClientBooking />
    </div>
  )
}

export default screen